import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';

export const AgeGroup = () => {
    const { chartData } = useIdentificationChartsDataContext();

    return (
        <SimpleBars
            title={'Faixa etária'}
            horizontal={true}
            subtitles={chartData?.ageGroup?.map((item) => item.description)}
            values={chartData?.ageGroup?.map((item) => item.total || 0)}
            className="aligned-container"
        />
    );
};
